/**
 * capacitorSetup.js
 *
 * Inicialización de APIs nativas de Capacitor al arrancar la app.
 * Solo se ejecuta en la app Android — en web es un no-op.
 */
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";

/**
 * Configura la StatusBar con el tema oscuro de SIT.
 * Llamar una vez al montar la app.
 */
export const initStatusBar = async () => {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark }); // íconos blancos
    await StatusBar.setBackgroundColor({ color: "#0a0a14" });
    await StatusBar.show();
  } catch (e) {
    console.warn("[CapSetup] StatusBar:", e?.message);
  }
};

/**
 * Oculta el splash screen nativo.
 * Llamar cuando la app ya cargó y está lista para mostrarse.
 */
export const hideSplashScreen = async () => {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch (e) {
    console.warn("[CapSetup] SplashScreen:", e?.message);
  }
};
